import React from 'react'

import { useOrderItemsModule } from '../contexts/OrderItemsModuleContext'
import { Summary, SummaryItem, SummaryLabel, SummaryValue } from '../Sections/Review.style'

const ReviewSummary: React.FC = () => {
  const { reviewSummary } = useOrderItemsModule()

  return (
    <Summary>
      {reviewSummary.map((line) => (
        <SummaryItem key={line.label}>
          <SummaryLabel emphasis={line.emphasis}>{line.label}</SummaryLabel>
          {line.value !== undefined && <SummaryValue>{line.value}</SummaryValue>}
        </SummaryItem>
      ))}
    </Summary>
  )
}

export default ReviewSummary
